type ApplicationMarketStateProps = {
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  hasServerApplications: boolean
  hasAccessibleApplications: boolean
  onRetry: () => void
}

export const ApplicationMarketState = ({
  isLoading,
  isFetching,
  isError,
  hasServerApplications,
  hasAccessibleApplications,
  onRetry,
}: ApplicationMarketStateProps) => {
  if (isLoading || (isFetching && !hasAccessibleApplications)) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="application-catalog-loading">
        Loading Applications and Markets...
      </div>
    )
  }

  if (isError) {
    return (
      <div
        className="flex min-h-screen flex-col items-center justify-center gap-4"
        data-testid="application-catalog-error"
      >
        <p>Applications and Markets could not be loaded.</p>
        <button type="button" onClick={onRetry}>
          Retry
        </button>
      </div>
    )
  }

  if (!hasServerApplications) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="application-catalog-empty">
        No applications are currently available. Please contact your administrator.
      </div>
    )
  }

  if (!hasAccessibleApplications) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="application-catalog-no-access">
        You do not have access to any applications. Please contact your administrator.
      </div>
    )
  }

  return null
}
